import React, { Component } from "react";
import SignUp from "../../components/Buttons/SignUp";

import { css, StyleSheet } from "aphrodite/no-important";

class custom_a extends Component {
  render() {
    return (
      <div className="container marketingSection">
        <div className="row">
          <div className="col-md-8">
            <h3>Start growing your business today with Yoco.</h3>
          </div>
          <div className="col-md-4">
            <SignUp
              className={`${css(styles.button)} d-block`}
              text="Sign up now"
            />
            <a
              className={`${css(styles.link)} tinyLink d-block`}
              href="/contact"
            >
              Request more information
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default custom_a;

const styles = StyleSheet.create({
  link: {},
  button: {
    marginTop: "0px",
    maxWidth: "150px",
    margin: "0px auto",
    marginBottom: "10px"
  }
});



// WEBPACK FOOTER //
// ./src/sections/layouts/custom_a.js